import React from 'react'
import image from '../../assets/icons/atom.png'
import image1 from '../../assets/icons/coding.png'
import image2 from '../../assets/icons/design.png'
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';


export default function Experiences() {
  return <>
    <section id='experiences' className='py-5 about-section'>
      <div className="container">
        <div className="row">
          <div className="col-md-12 d-flex justify-content-center">
            <h6 className='text-muted'> What we provide?</h6>
          </div>
          <div className="col-md-12 d-flex justify-content-center">
            <h3 className='heading-e '> Our Services.</h3>
          </div>
        </div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-12">
            <VerticalTimeline>

              <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: "#fff", color: "#111", }}
                contentArrowStyle={{ borderRight: "7px solid  #267" }}
                iconStyle={{ background: '#FFFFF', color: '#fff' }}
                icon={<img className='w-100' src={image1} alt="" />}
              >
                <h3 className="vertical-timeline-element-title">Cloud Computer Services</h3>
                <ul className='text-muted mt-3'>
                  <li className='py-2'>Superior Performance: Emphasize the exceptional performance of your virtual machines, backed by state-of-the-art hardware and optimized configurations. Highlight their ability to deliver fast and responsive computing power, enabling resource-intensive applications to run smoothly and efficiently.</li>
                  <li className='py-2'>Reliability and Uptime: Emphasize the reliability of your virtual machine infrastructure, backed by redundant systems, robust network connectivity, and proactive monitoring. Highlight the high uptime guarantees you provide, ensuring that customers' websites and applications remain accessible and operational without interruptions.</li>
                  <li className='py-2'>Dedicated Support: Showcase your commitment to customer satisfaction by highlighting your dedicated support team. Emphasize the 24/7 availability of knowledgeable technical experts who can assist customers with any issues or questions they may have, providing prompt and reliable support.</li>
                </ul>
              </VerticalTimelineElement>


              <VerticalTimelineElement
                className="vertical-timeline-element--work"
                contentStyle={{ background: "#fff", color: "#111", }}
                contentArrowStyle={{ borderRight: "7px solid  #267" }}
                iconStyle={{ background: '#FFFFF', color: '#fff' }}
                icon={<img className='w-100' src={image2} alt="" />}
              >
                <h3 className="vertical-timeline-element-title">SRO Services</h3>
                <ul className='text-muted mt-3'>
                  <li className='py-2'>Our virtual machines have successfully bypassed IP limits, ensuring seamless access to Silkroad private servers. Each VPS is meticulously configured with the latest updates, guaranteeing optimal performance.</li>
                  <li className='py-2'>In addition, we offer a wide range of services to enhance your Silkroad experience. We provide cutting-edge scripts and bots, including the latest plugins such as SBOT and PHBOT. These tools empower you to automate various tasks, maximizing your efficiency in the game.</li>
                  <li className='py-2'>Moreover, our platform caters to all your Silkroad needs. Whether you're looking to sell or buy in-game resources like gold, silk, or items, we have you covered. Our services extend to most private servers currently prevalent in the Silkroad community.</li>
                </ul>
              </VerticalTimelineElement>


            </VerticalTimeline>

          </div>
        </div>
      </div>



    </section>



  </>
}
